import { createSlug } from '../../utils/helpers';
import { getClient, listClients, upsertClient } from '../../api/companyRecords';

export function getClientDisplayName(client) {
  if (!client) return '';
  const fromParts = `${client.firstName || ''} ${client.lastName || ''}`.trim();
  return client.name || fromParts || String(client.searchName || '').trim();
}

/** Prefer stored slug, then record id — for /clients/profile URLs. */
export function getCompanyClientUrlSegment(client) {
  if (!client) return '';
  const slug = String(client.slug || '').trim();
  if (slug) return slug;
  return client.id ? String(client.id) : '';
}

export function assignUniqueClientSlug(displayName, existingClients = [], excludeId = null) {
  const base = createSlug(displayName) || 'client';
  const taken = new Set(
    existingClients
      .filter((client) => client?.id && client.id !== excludeId)
      .map((client) => String(client.slug || '').trim())
      .filter(Boolean)
  );

  let slug = base;
  let suffix = 2;
  while (taken.has(slug)) {
    slug = `${base}-${suffix}`;
    suffix += 1;
  }
  return slug;
}

export function buildClientSlugFields(client, existingClients = [], excludeId = null) {
  const displayName = getClientDisplayName(client);
  return {
    slug: assignUniqueClientSlug(displayName, existingClients, excludeId),
  };
}

export async function resolveCompanyClient(companyId, param) {
  if (!companyId || param == null || String(param).trim() === '') return null;

  const paramStr = String(param).trim();
  try {
    const direct = await getClient({ companyId, id: paramStr });
    if (direct?.id) return direct;
  } catch (error) {
    if (error.status && error.status !== 404) throw error;
  }

  const clients = await listClients({ companyId, archived: 'all' });
  return clients.find((client) => String(client.slug || '').trim() === paramStr) || null;
}

export async function ensureCompanyClientSlug(companyId, clientId, clientData) {
  if (!companyId || !clientId) return '';

  const existingSlug = String(clientData?.slug || '').trim();
  if (existingSlug) return existingSlug;

  const existingClients = await listClients({ companyId, archived: 'all' });
  const slug = assignUniqueClientSlug(getClientDisplayName(clientData), existingClients, clientId);
  await upsertClient({
    companyId,
    id: clientId,
    client: { slug, updatedAt: new Date().toISOString() },
  });
  return slug;
}
